import { PaginatedResult } from '../../data/type';
import { createPager } from '../factories';
import { KalturaFilterPager } from '../objects';

interface FetchAllPagesParams<T> {
  request: (pager: KalturaFilterPager) => Promise<PaginatedResult<T>>;
  pageSize: number;
}

export async function fetchAllPages<T>({ pageSize, request }: FetchAllPagesParams<T>): Promise<PaginatedResult<T>> {
  const firstPageResponse = await request(createPager({ pageIndex: 1, pageSize }));

  const totalCount = firstPageResponse.totalCount;

  if (totalCount <= pageSize || !firstPageResponse.objects) {
    return {
      totalCount,
      objects: firstPageResponse.objects ?? [],
    };
  }

  const totalPages = Math.ceil(firstPageResponse.totalCount / pageSize);

  const responses = await Promise.all(
    Array.from({ length: totalPages - 1 }).map((_value, index) =>
      request(createPager({ pageIndex: index + 2, pageSize })),
    ),
  );

  const objects = firstPageResponse.objects.concat(responses.flatMap((response) => response.objects ?? []));

  return {
    objects,
    totalCount: firstPageResponse.totalCount,
  };
}
